module.exports = "<p>\r\n  imprint works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/imprint/imprint.component.html
// module id = ../../../../../src/app/components/imprint/imprint.component.html
// module chunks = 0